import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';


@Injectable()
export class AuthExternoGuardService implements CanActivate {

	constructor(private authService: AuthService, private activedRoute: ActivatedRoute, private router: Router) { }

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		if (state.url.startsWith('/detalle-consulta-solicitud/')) {
			return true;
		} else {
			return this.authService.validarKey(state.root.firstChild.paramMap.get('key'));
		}
	}
}
